/*# sourceMappingURL=mo-shortcode-table.component-6USV2WUZ.css.map */
